import { Brand, createBranded } from '@deltasierra/type-utilities';

/**
 * @deprecated Use the `LearnId` instead.
 */
export type TryThisId = Brand<number, 'TryThisId'>;
/**
 * @deprecated Use the `LearnId` instead.
 */
export const TryThisId = createBranded<TryThisId>();
